import Vue from 'vue';
import { setGlobalDateMasks } from 'fecha';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vuelidate from 'vuelidate';
import VueKeyCloak from '@dsb-norge/vue-keycloak-js';

import VueTransmit from 'vue-transmit';
import App from './App.vue';
import router from './router';
import store from './store';
import config from './config';
import './styles/main.scss';
import AuthApi from "@/api/AuthApi";


Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueTransmit);

// FA
library.add(config.icons);
Vue.component('font-awesome-icon', FontAwesomeIcon);

setGlobalDateMasks({
  default: 'DD.MM.YYYY, HH:mm:ss'
});

const mountVueApp = () => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
}

if (config.authenticationMethods.includes('keycloak')) {
  // Keycloak authentication enabled, wait for it to initialize before mounting the app
  const authApi = new AuthApi(config.authEndpoint);
  authApi.getKeycloakConfigurations().then(keycloakConfig => {
    Vue.use(VueKeyCloak, {
      init: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        redirectUri: keycloakConfig.keycloak.redirectUri,
      },
      config: {
        url: keycloakConfig.keycloak.url,
        clientId: keycloakConfig.keycloak.clientId,
        realm: keycloakConfig.keycloak.realm
      },
      onReady(keycloak) {
        console.log("Keycloak ready, initializing app");
  
        mountVueApp();
      },
      onInitError() {
        console.log("TODO: error page when keycloak doesn't respond??");
      }
    })
  })
} else {
  // Keycloak authentication not enabled, just mount the app
  mountVueApp();
}

